module.exports = __webpack_public_path__ + "static/Nora-Huovila-52f894f1ead7828cc7e12a7848b32ddf.jpeg";